<template>
  <div class="app-container">
    <list ref="list" @change="onChange" @reload="reload">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="95">
          <template slot-scope="{row}">
            <template v-if="row.Status<2">
              <template v-if="$permission.canWrite()">
                <el-button type="text" @click.stop="editById(row.DocId)">编辑</el-button>
              </template>
              <template v-if="$permission.canWrite()">
                <el-button type="text" @click.stop="review(row)">审核</el-button>
              </template>
            </template>
            <template v-else-if="row.Status==2">
              <el-button type="text" @click.stop="details(row)">查看</el-button>
            </template>
          </template>
        </el-table-column>
      </template>
    </list>
    <div class="list-head" style="margin-top: 10px;">
      <span>付款信息</span>
    </div>
    <el-table class="tb-c-head" show-summary :data="Details" v-loading="isLoading" border>
      <el-table-column label="结算方式" min-width="120px">
        <template slot-scope="{row}">{{row.SettleName}}</template>
      </el-table-column>
      <el-table-column label="付款账号" min-width="150px">
        <template slot-scope="{row}">{{row.AccountName}}</template>
      </el-table-column>
      <el-table-column label="付款金额" prop="PayAmount" width="110px" />
      <el-table-column label="备注" min-width="200px" show-overflow-tooltip>
        <template slot-scope="{row}">{{row.Remark}}</template>
      </el-table-column>
    </el-table>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <details-dialog ref="detailsDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/cashier/paydoc/list";
import editDialog from "@/components/cashier/paydoc/editDialog";
import detailsDialog from "@/components/cashier/paydoc/detailsDialog";

export default {
  name: "paydoc",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    detailsDialog,
  },
  mounted() {},
  data() {
    return {
      api: require("@/api/rp/pay").default,
      Details: [],
      isLoading: false,
    };
  },
  methods: {
    reload() {
      this.$refs.list.reload();
      this.Details = [];
    },
    onChange(row) {
      console.log("选中行", JSON.parse(JSON.stringify(row)));
      this.Details = [];
      this.isLoading = true;
      this.api.info(row.DocId).then((res) => {
        this.isLoading = false;
        if (res.Data) this.Details = res.Data.Dts;
      });
    },
    review(row) {
      this.$refs.detailsDialog.openEditById(row.DocId);
    },
    details(row) {
      this.$refs.detailsDialog.openDetailsById(row.DocId);
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.DocId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>